import i18n from "@/i18n";
import { MainNavigationVue } from "fs-pb-vue2/vueModels/navigation/MainNavigationVue";
import IAlertService from "fs-pb-vue2/services/alert/IAlertService";
import { container } from "@/inversify.config";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import { ContractsApi } from "fs-pb-vue2/services/api/ContractsApi";
import { ContractModel } from "fs-pb-vue2/models/contracts/contractModel";
import { CardModel } from "fs-pb-vue2/models/contracts/cardModel";
import { ContractsStore } from "fs-pb-vue2/store/modules/contracts";
import { getModule } from "vuex-module-decorators";

export class MainNavigationVueGB extends MainNavigationVue {
  
  /**Стор счетов */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  searchQuery: string = '';

  /**Переход к странице Профиля */
  get toProfile(): () => void {
    return () => {
      this.$router.push("/profile");
    };
  }

  /** Список ссылок в меню */
  links: Array<any> = [
    { 
      title: this.$i18n.t("main.header.links.main"), 
      url: "/", exact: true,
      image: 'mobile-menu-logo',
      action: () => this.goToMain()
    },
    { 
      title: this.$i18n.t("main.header.links.payments"), 
      url: "/payments",
      image: 'mobile-menu-payments'
    },
    { 
      title: this.$i18n.t("main.header.links.support"), 
      url: "/support",
      image: 'mobile-menu-support'
    },
    { 
      title: this.$i18n.t("main.header.links.showcase"), 
      url: "/showcase",
      image: 'mobile-menu-showcase'
    },
    { 
      title: this.$i18n.t("main.header.links.history"), 
      url: "/history",
      image: 'mobile-menu-history',
      action: () => this.goToMain()
    }
    // { title: this.$i18n.t("main.header.links.settings"), url: "/settings" }
    // {
    //   title: this.$i18n.t("main.header.links.authHistory"),
    //   url: "/authHistory"
    // }
  ];

  searchCatalog(): void {
    if (this.searchQuery.length) {
      this.$router.push(`/payments?query=${this.searchQuery}`);
      this.searchQuery = '';
    } else {
      this.alertService.warning('Строка поиска должна включать в себя более одного символа');
    }
  }

  goToMain(): void {
    this.contractsStore.addMethod(() => {
  		this.contractsStore.contracts.Contracts.map((contract: ContractModel) => {
        contract.StatementModel.isPeriod = true;
        if (contract.Cards.length > 0) {
          contract.Cards.map(async (card: CardModel) => {
            card.StatementModel.isPeriod = true;
            try {
              const res: any = await ContractsApi.getCardRest(card.Data.Id);
              if (res) {
                for (const key in res) {
                  if (res[key].Properties.SummaCode === 'AvailBalance') {
                    card.Data.Rest = res[key].Properties.CurrentSumma;
                  }
                }
              }
            } catch (e: any) {
              this.alertService.error(e.messsage);
            }
          });
        }
      });
  	});
    this.contractsStore.fetchContracts();
  }

  handleLinkClick(link: any): void {
    if (link.action) {
      link.action();
    }
  }

  deleteCookie(name: string): void {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

  /**Выход из системы */
  async logout() {
    await this.authService.logout();
    this.configStore.clearPreApprovedSolutionData();
    this.deleteCookie('isAllChargesVisible');
    sessionStorage.removeItem('modalShown');
  }
}
